import styled from "styled-components";

export const SkeletonBox = styled.div`
  margin-top: 15px;
`;
